import { billing } from '@/services/billing';
import type { ActivityHistory, ActivityHistoryKind } from '../utils/activity-history';
import { useAddonPurchase } from './use-addon-purchase';

export function useOpenActivityHistoryAddon(
  kind: ActivityHistoryKind,
  { lookbackStart, addonLookbackStart }: ActivityHistory,
): () => Promise<void> {
  const { openAddon } = useAddonPurchase();

  return async () => {
    const purchase = await openAddon({ request: { key: 'activity-history', kind, lookbackStart, addonLookbackStart } });
    if (purchase?.isPurchased === true) {
      await billing.initialize.perform({ refresh: true, ignoreErrors: true });
    }
  };
}
